import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Button from '@mui/material/Button';
import AuthRoutes from '@/constants/routing/AuthRoutes';
import translate from '@/lib/intl/translate';

export default function BackToUploadsButton() {
  return (
    <Button component={RouterLink} to={AuthRoutes.COMPANY_DATA_UPLOADS}>
      {translate('DATA_UPLOADS_BACK_TO_UPLOADS')}
    </Button>
  );
}
